import React, { useState, useEffect } from 'react';
import { useLanguage } from 'Context/LanguageContext';
import { getAutoAssignTaskRequest } from '@core/api/autoAssign/autoAssign.service';
import { useDispatch } from 'react-redux';
import { Dialog, DialogTitle, DialogContent, IconButton, Box, Container, } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import AutoAssignInfo from './components/AutoAssignInfo';
import { StyleFielderTitleTypography } from '~/FielderElements/FielderElements.styles';

export default function AutoAssignDetail(props) {
  const { idTask, taskTypes, setDetail } = props;
  const lan = useLanguage();
  const dispatch = useDispatch();
  const [processTask, setProcessTask] = useState(null);
  useEffect(() => {
    if (!idTask) return;
    const body = { taskId: idTask };
    const onSuccess = (res) => setProcessTask(res.processTask);
    const loadingConfig = { dispatch };
    getAutoAssignTaskRequest(body, onSuccess, null, loadingConfig);
  }, [idTask, dispatch]);
  const handleClose = () => setDetail?.(null);
  return (
    <Dialog open onClose={handleClose} fullWidth maxWidth="lg" sx={{ borderRadius: 2 }}>
      {/* Header */}
      <DialogTitle sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
        <Box component="span" sx={{ flexGrow: 1 }}>
          <StyleFielderTitleTypography variant={'h6'}>{lan.autoassignDetail}</StyleFielderTitleTypography>
        </Box>
        <IconButton onClick={handleClose} aria-label="Close">
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      {/* Body */}
      <DialogContent dividers sx={{ px: { xs: 2, md: 3 }, py: 2, }}>
        <Container disableGutters sx={{ height: 500, overflow: 'auto', }}>
          <AutoAssignInfo processTask={processTask} taskTypes={taskTypes} />
        </Container>
      </DialogContent>
    </Dialog>
  );
}
